export interface DataEntity_Main_06_Interface {
    id: number,
    calibration_id: number,
    filename: string,

    pdf_src: string,

    manufacture: string,
    model: string,
    type: string,
    capability: string,

    unit_working: string,
    unit_reference: string,
    unit_indication: string,
    unit_deviation: string,
    unit_uncertainty: string,
    unit_correction_eqution: string,

    working_min: string,
    working_max: string,
    accuracy: string,

    working_type: number,

    ////Mohit
    temperature_Air_before: string,
    temperature_Air_after: string,

    humidity_Air_before: string,
    humidity_Air_after: string,

    pressure_before: string,
    pressure_after: string,

}

export function Empty_DataEntity_Main_06_Interface(): DataEntity_Main_06_Interface {
    return {
        id: 0,
        calibration_id: 0,
        filename: '',

        pdf_src: '',

        manufacture: '',
        model: '',
        type: '',
        capability: '',

        unit_working: '',
        unit_reference: '',
        unit_indication: '',
        unit_deviation: '',
        unit_uncertainty: '',
        unit_correction_eqution: '',

        working_min: '',
        working_max: '',
        accuracy: '',

        working_type: 0,

        ////Mohit


        temperature_Air_before: '',
        temperature_Air_after: '',

        humidity_Air_before: '',
        humidity_Air_after: '',

        pressure_before: '',
        pressure_after: '',


    }
}
